import classNames from 'classnames';
import React, { memo } from 'react';

interface SubtitleProps {
  text: string;
  className?: string;
}

const Subtitle: React.FC<SubtitleProps> = ({ text, className }) => {
  return (
    <p
      className={classNames(
        'text-button/primary-bg text-sm uppercase',
        className
      )}
    >
      {text}
    </p>
  );
};

export default memo(Subtitle);
